import Component from '../core/Component'
import { queries } from '../core/config'
import PositionObserver from '../meta/PositionObserver'

export default class SnowFall extends Component {
    prepare() {
        this.snowFall = createSnowFall(this.element)
        this.snowFall.prepare()
        
        this.positionObserver = new PositionObserver(this.element, {
            onEnter: () => this.snowFall.play(), 
            onLeave: () => this.snowFall.pause() 
        })
    }

    destroy() {
        this.snowFall?.destroy()
        this.positionObserver?.destroy()
    }
}

function createSnowFall(element, options = {}) {
    options = {
        particleCount: 400,
        particleSize: 3,
        fallingSpeed: .3,
        colors: ['#ccc', '#eee', '#fff', '#ddd'],
        ...options,
        mobileOptions: {
            particleCount: 80,
            fallingSpeed: .15,
            ...options?.mobileOptions
        },
    }

    let canvas = document.querySelector('canvas', element)
    if (!canvas) {
        canvas = document.createElement('canvas')
        element.appendChild(canvas)
    }
    const ctx = canvas.getContext('2d')

    let isPaused = false
    let particles = []
    let lastWindowWidth = null

    const resize = () => {
        const _windowWidth = window.innerWidth
        if (lastWindowWidth === _windowWidth) {
            return
        }
        const rect = element.getBoundingClientRect()
        canvas.width = rect.width
        canvas.height = rect.height
        lastWindowWidth = _windowWidth
        setupParticles()
    }

    function randomIntFromRange(min, max) {
        return Math.floor(Math.random() * (max - min + 1) + min)
    }

    function randomColor(colors) {
        return colors[Math.floor(Math.random() * colors.length)]
    }

    function Particle(x, y, radius, color, radians, speed) {
        this.x = x
        this.y = y
        this.radius = radius
        this.color = color
        this.radians = radians
        this.velocity = 0.005

        this.update = () => {
            this.radians += this.velocity
            this.x = x + Math.cos(this.radians) * 400 * speed
            this.y = y + Math.tan(this.radians) * 600 * speed

            this.draw()
        }

        this.draw = () => {
            ctx.beginPath()
            ctx.arc(this.x, this.y, this.radius, 0, Math.PI * 2, false)
            ctx.fillStyle = this.color
            ctx.fill()

            ctx.closePath()
        }
    }

    const setupParticles = () => {
        particles = []
        const _options = window.matchMedia(queries.smallWideMax).matches ?  {...options,...options.mobileOptions} : options

        for (let i = 0; i < _options.particleCount; i++) {
            particles.push(
                new Particle(
                    Math.random() * canvas.width,
                    Math.random() * canvas.height,
                    randomIntFromRange(2, _options.particleSize),
                    randomColor(_options.colors),
                    Math.random() * 80,
                    _options.fallingSpeed
                )
            )
        }
    }

    const prepare = () => {
        resize()
        setupParticles()
        window.addEventListener('resize', resize)
    }

    const destroy = () => {
        window.removeEventListener('resize', resize)
    }

    const pause = () => {
        cancelAnimationFrame(animate)
        isPaused = true
    }
    
    const play = () => {
        isPaused = false
        animate()
    }

    const animate = () => {
        if (isPaused) {
            return
        }
        requestAnimationFrame(animate)
        ctx.clearRect(0, 0, canvas.width, canvas.height)

        particles.forEach(particle => {
            particle.update()
        })
    }

    return {
        prepare,
        destroy,
        play,
        pause
    }
}